/**
 * Cloud Elements tab: suggested filter keys and shared constants.
 * Column definitions stay in ReflectorDetailsData (cloudElementsColumns) and
 * ClusterDetailsData (clusterCloudElementsColumns) since they differ per context.
 */

export const CLOUD_ELEMENTS_SUGGESTED_KEYS_REFLECTOR = [
  'Type',
  'Element ID',
  'VPC',
  'Region',
  'Tags',
  'Discovered At',
] as const;

export const CLOUD_ELEMENTS_SUGGESTED_KEYS_CLUSTER = [
  'Type',
  'Element ID',
  'VPC',
  'Region',
  'Tags',
  'Discovered At',
  'Discovered By',
] as const;

export const CLOUD_ELEMENTS_EMPTY_TITLE = 'No cloud elements yet';
export const CLOUD_ELEMENTS_EMPTY_DESCRIPTION_REFLECTOR =
  'Cloud elements discovered for this reflector will appear here.';
export const CLOUD_ELEMENTS_EMPTY_DESCRIPTION_CLUSTER =
  'Cloud elements discovered for this cluster will appear here.';
export const CLOUD_ELEMENTS_ERROR_TITLE = 'Failed to load cloud elements';
